import { IconInfoCircleFilled } from '@tabler/icons-react'

import { AstraCallout, AstraParagraph } from '~/astra'
import env from '~/env'
import { showUserFeedbackForm } from '~/utils/sentry'

export const EmptyPractitionerWaitingListCallout = () => (
    <AstraCallout
        icon={IconInfoCircleFilled}
        text={
            <div className="flex flex-col gap-3">
                <AstraParagraph>Det kan likevel finnes pasienter på felles ventelister.</AstraParagraph>
                {env.VITE_ENABLE_SENTRY_USER_FEEDBACK && (
                    <AstraParagraph>
                        Er dette feil?{' '}
                        <span onClick={showUserFeedbackForm} className="cursor-pointer text-brand underline">
                            Gi gjerne en tilbakemelding her
                        </span>{' '}
                        og skriv hva du forventet å se.
                    </AstraParagraph>
                )}
            </div>
        }
    />
)
